"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This class provides a way of retrieving and indexing events
 *
 * @class
 */
var EventMap = function () {
  function EventMap(_ref) {
    var _this = this;

    var map = _ref.map,
        names = _ref.names,
        props = _ref.props;
    (0, _classCallCheck3.default)(this, EventMap);

    this.isEventName = function (name) {
      return _this.props.names.indexOf(name) !== -1;
    };

    this.getEventKey = function (eventName) {
      return _this.props.map.hasOwnProperty(eventName) ? _this.props.map[eventName] : null;
    };

    this.getEventProps = function (eventName) {
      var eventKey = _this.getEventKey(eventName);
      if (eventKey && _this.props.props.hasOwnProperty(eventKey)) {
        return _this.props.props[eventKey];
      }
    };

    this.props = { map: map, names: names, props: props };
  }

  /**
   * @method
   * @public
   *
   * @param {String} name
   * @return boolean
   */


  (0, _createClass3.default)(EventMap, [{
    key: "eventNames",


    /**
     * @public
     *
     * @type {Array.<String>}
     */
    get: function get() {
      return [].concat(this.props.names);
    }

    /**
     * Returns the event key given an event name
     *
     * @method
     * @public
     *
     * @param {String} eventName
     * @return {string}
     */


    /**
     * Returns the event properties
     *
     * @method
     * @public
     *
     * @param eventName
     * @return {object|null}
     */

  }]);
  return EventMap;
}();

exports.default = EventMap;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Core/EventMap.js
// module id = 309
// module chunks = 0